module.exports = __webpack_public_path__ + "static/media/cat-face-2.a1664d2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/cat-face-2.jpg
// module id = 245
// module chunks = 1